import {
  USER_CHECK,
  USER_CHECK_FAILURE,
  USER_CHECK_SUCCESS,
  USER_HIDE_SUCCESS,
  USER_LOADING_HIDE,
  USER_LOADING_SHOW,
  USER_SHOW_SUCCESS,
  USER_SIGN_IN_FAILURE,
  USER_SIGN_IN_SUCCESS,
  USER_SIGN_OUT_SUCCESS,
} from "@shared/constants";

import { initialErrorState, setError } from "./error";
import { createReducer } from "./utils";

const initialState = {
  user: {},
  loading: false,
  success: false,
  error: initialErrorState,
  userFetchStatus: "initial",
};

export default createReducer(initialState, {
  [USER_LOADING_SHOW](state) {
    return Object.assign({}, state, { loading: true });
  },

  [USER_LOADING_HIDE](state) {
    return Object.assign({}, state, { loading: false });
  },

  [USER_SHOW_SUCCESS](state) {
    return Object.assign({}, state, { success: true });
  },

  [USER_HIDE_SUCCESS](state) {
    return Object.assign({}, state, { success: false });
  },

  [USER_CHECK](state) {
    return Object.assign({}, state, {
      userFetchStatus: "pending",
    });
  },

  [USER_CHECK_SUCCESS](state, action) {
    return Object.assign({}, state, {
      error: initialErrorState,
      user: action.payload,
      userFetchStatus: "success",
    });
  },

  [USER_CHECK_FAILURE](state, action) {
    return Object.assign({}, state, {
      error: setError(state.error, action.payload),
      userFetchStatus: "failure",
    });
  },

  [USER_SIGN_IN_SUCCESS](state, action) {
    return Object.assign({}, state, {
      user:
        action.payload[0] && action.payload[0].user?.casino_id
          ? action.payload[0].user
          : state?.user?.user,
      error: initialErrorState,
    });
  },

  [USER_SIGN_IN_FAILURE](state) {
    return Object.assign({}, state, {
      error: setError(state.error, "sign-in-error"),
    });
  },

  [USER_SIGN_OUT_SUCCESS]: () => {
    return initialState;
  },
});
